module.exports = __webpack_public_path__ + "static/media/disabled_checkbox.d6999af1.svg";